module.exports = __webpack_public_path__ + "img/img.d7758b94.jpg";